'use client'

import React, { type PropsWithChildren, useState } from 'react'

import { VideoPlayerModal } from './VideoPlayerModal'

interface VideoPopupCTAProps {
  videoId: string
  playerId?: string
  autoplay?: boolean
}

export const VideoPopupCTA = ({
  children,
  videoId,
  playerId,
  autoplay,
}: PropsWithChildren<VideoPopupCTAProps>) => {
  const [isModalOpen, setIsModalOpen] = useState(false)
  return (
    <div className="relative block aspect-video w-full max-w-full">
      <div
        role="button"
        tabIndex={0}
        onClick={() => {
          setIsModalOpen(true)
        }}
        onKeyUp={() => {
          setIsModalOpen(true)
        }}
      >
        {children}
      </div>
      <VideoPlayerModal
        videoId={videoId}
        playerId={playerId}
        autoplay={autoplay}
        isOpen={isModalOpen}
        onClose={() => {
          setIsModalOpen(false)
        }}
      />
    </div>
  )
}
